import { _ } from "../../polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";
import FiscalYearWidget from "./FiscalYearWidget.js";
import OldSpinnerWidget from "../../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner
import regionWidget from "../regionWidget.js";

/**
 * `fiscalYearListWidget` renders a list of fiscalYear widgets. It
 * shows by default the most recent years, set by
 * `numberOfVisibleYears`, with the option to toggle all fiscal
 * years.
 *
 * @param {{}} spec - Parameter object
 * @param {Array} spec.fiscalYears - List of fiscal years
 * @param {number} [spec.numberOfVisibleYears] - The number last fiscalYear to show by default
 * @param {chartOfAccounts[]} spec.chartsOfAccounts - List of selectable chart of accounts
 * @param {{}} my - protected fields holder
 * @return {*}
 */
export default function fiscalYearListWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	let fiscalYears = spec.fiscalYears || [];
	const numberOfVisibleYears = spec.numberOfVisibleYears || 2;
	let showAllYears = false;

	my.chartsOfAccounts = spec.chartsOfAccounts || [];

	that.setFiscalYears = function (newFiscalYears) {
		fiscalYears = newFiscalYears;
		that.update();
	};

	that.setChartsOfAccounts = function (chartsOfAccounts) {
		my.chartsOfAccounts = chartsOfAccounts;
		that.update();
	};

	that.onDeleteFiscalYear = my.events.createEvent();
	that.onDeleteBudget = my.events.createEvent();
	that.onSaveFiscalYear = my.events.createEvent();

	my.fiscalYearToggler = regionWidget({
		content: function (html) {
			html.p(
				{ klass: "clearfix" },
				html
					.a(
						{ klass: "pull-right toggle-all-fiscal-years" },
						(html) => {
							if (showAllYears) {
								html.render(_("Hide old fiscal years"));
							} else {
								html.render(_("Show older fiscal years"));
							}
						},
					)
					.click(toggleOldFiscalYears),
			);
		},
	});

	// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
	my.spinnerWidget = new OldSpinnerWidget({
		size: 64,
	});

	that.renderContentOn = function (html) {
		if (!fiscalYears.length) {
			return;
		}

		if (!my.chartsOfAccounts.length) {
			my.renderLoading(html);
			return;
		}
		if (sortedFiscalYears().length <= numberOfVisibleYears) {
			html.render(sortedFiscalYears().map(createFiscalYearWidget));
		} else {
			html.render(
				sortedFiscalYears()
					.slice(0, numberOfVisibleYears)
					.map(createFiscalYearWidget),
			);

			html.div(
				{ klass: "older-fiscal-years" },
				fiscalYears
					.slice(numberOfVisibleYears)
					.map(createFiscalYearWidget),
			);

			html.render(my.fiscalYearToggler);
		}
	};

	my.renderLoading = function (html) {
		html.div({ "data-test": "fiscal-years-spinner" }, my.spinnerWidget);
	};

	function sortedFiscalYears() {
		return fiscalYears.sort((year1, year2) =>
			year1.endsBefore(year2) ? 1 : -1,
		);
	}

	function toggleOldFiscalYears() {
		showAllYears = !showAllYears;
		that.asJQuery().find(".older-fiscal-years").slideToggle();
		my.fiscalYearToggler.update();
	}

	function createFiscalYearWidget(year) {
		const fiscalYear = new FiscalYearWidget({
			fiscalYear: year,
			chartsOfAccounts: my.chartsOfAccounts,
		});

		fiscalYear.onSaveYear.register(() => {
			that.onSaveFiscalYear.trigger(year);
		});

		fiscalYear.onDeleteYear.register(() => {
			that.onDeleteFiscalYear.trigger(year);
		});

		// eslint-disable-next-line no-shadow -- bad practice, we should fix this
		fiscalYear.onDeleteBudget.register((budget, fiscalYear, callback) => {
			that.onDeleteBudget.trigger(budget, fiscalYear, callback);
		});

		return fiscalYear;
	}

	return that;
}
